export default "__VITE_ASSET__BYekhnXa__"